import { createContext, useContext } from 'react'
import type { NotificationSetupState } from '@/features/notifications/browserPush'

/**
 * What Settings can ask the app shell to do. The dialogs (Change name, Push
 * notifications, About, the unsynced sign-out warning) stay in the shell, as
 * they did for the menu, so they work the same from anywhere.
 */
export type AccountActions = Readonly<{
  changeName: () => void
  pushNotifications: () => void
  about: () => void
  signOut: () => void
  notificationState: NotificationSetupState
}>

export const AccountActionsContext = createContext<AccountActions | null>(null)

export function useAccountActions(): AccountActions {
  const value = useContext(AccountActionsContext)
  if (!value) throw new Error('useAccountActions must be used within AppShell.')
  return value
}
